import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {asArray, asText} from "./ClinicalReportSummaryParts";

const useStyles = makeStyles((theme) => ({
    findingTitleList: {
        margin: theme.spacing(1, 0, 2, 0),
        paddingLeft: theme.spacing(3),
    },
    confirmationCheckbox: {
        alignItems: "flex-start",
        marginBottom: theme.spacing(1),
        "& .MuiCheckbox-root": {
            paddingTop: 0,
        },
    },
}));

const ClinicalReportCopyConfirmationDialog = ({open, findings, onConfirm, onCancel}) => {
    const classes = useStyles();
    const {t: translate} = useTranslation();
    const [isAiSummaryChecked, setIsAiSummaryChecked] = useState(false);
    const [isCriticalFindingsRead, setIsCriticalFindingsRead] = useState(false);

    useEffect(() => {
        if (open) {
            setIsAiSummaryChecked(false);
            setIsCriticalFindingsRead(false);
        }
    }, [open]);

    const findingTitles = asArray(findings)
        .filter((finding) => finding && typeof finding === "object")
        .map((finding) => asText(finding.title) || asText(finding.findingType))
        .filter(Boolean);

    const confirmCopy = () => onConfirm([
        translate("clinicalReportSummarizer.confirmation.copyDialog.aiSummaryChecked"),
        translate("clinicalReportSummarizer.confirmation.copyDialog.criticalFindingsRead"),
    ]);

    return (
        <Dialog open={open} onClose={onCancel} maxWidth={"sm"} fullWidth>
            <DialogTitle>{translate("clinicalReportSummarizer.confirmation.copyDialog.title")}</DialogTitle>
            <DialogContent>
                <Typography>{translate("clinicalReportSummarizer.confirmation.copyDialog.lead")}</Typography>
                <ul className={classes.findingTitleList}>
                    {findingTitles.map((findingTitle, findingTitleIndex) => (
                        <li key={`${findingTitleIndex}-${findingTitle}`}><Typography>{findingTitle}</Typography></li>
                    ))}
                </ul>
                <FormControlLabel
                    className={classes.confirmationCheckbox}
                    control={
                        <Checkbox
                            color={"primary"}
                            checked={isAiSummaryChecked}
                            onChange={(aiSummaryCheckboxChangeEvent) => setIsAiSummaryChecked(aiSummaryCheckboxChangeEvent.target.checked)}
                        />
                    }
                    label={translate("clinicalReportSummarizer.confirmation.copyDialog.aiSummaryChecked")}
                />
                <FormControlLabel
                    className={classes.confirmationCheckbox}
                    control={
                        <Checkbox
                            color={"primary"}
                            checked={isCriticalFindingsRead}
                            onChange={(criticalFindingsCheckboxChangeEvent) => setIsCriticalFindingsRead(criticalFindingsCheckboxChangeEvent.target.checked)}
                        />
                    }
                    label={translate("clinicalReportSummarizer.confirmation.copyDialog.criticalFindingsRead")}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{translate("clinicalReportSummarizer.confirmation.copyDialog.cancel")}</Button>
                <Button
                    color={"primary"}
                    variant={"contained"}
                    disabled={!isAiSummaryChecked || !isCriticalFindingsRead}
                    onClick={confirmCopy}
                >
                    {translate("clinicalReportSummarizer.confirmation.copyDialog.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ClinicalReportCopyConfirmationDialog;
